// API Configuration
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4003/graphql';

// Environment
export const NODE_ENV = process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV || 'development';

// OTP Configuration
export const OTP_CONFIG = {
  LENGTH: parseInt(process.env.REACT_APP_OTP_LENGTH) || 6,
  EXPIRY_MINUTES: parseInt(process.env.REACT_APP_OTP_EXPIRY_MINUTES) || 5,
  RATE_LIMIT_MAX: parseInt(process.env.REACT_APP_OTP_RATE_LIMIT_MAX) || 3,
  RATE_LIMIT_WINDOW_HOURS: parseInt(process.env.REACT_APP_OTP_RATE_LIMIT_WINDOW_HOURS) || 1,
  TIMER_SECONDS: parseInt(process.env.REACT_APP_OTP_TIMER_SECONDS) || 300,
  BUTTON_DISABLE_SECONDS: parseInt(process.env.REACT_APP_BUTTON_DISABLE_SECONDS) || 3,
};

// Default Values
export const DEFAULTS = {
  PHONE: process.env.REACT_APP_DEFAULT_PHONE || '9106649835',
  COUNTRY: process.env.REACT_APP_DEFAULT_COUNTRY || 'IN',
  DEV_FIXED_OTP: process.env.REACT_APP_DEV_FIXED_OTP || '123456',
};

// Subscription Configuration
export const SUBSCRIPTION_CONFIG = {
  GRACE_PERIOD_DAYS: parseInt(process.env.REACT_APP_GRACE_PERIOD_DAYS) || 7,
  WARNING_DAYS: [
    parseInt(process.env.REACT_APP_WARNING_DAY_1) || 7,
    parseInt(process.env.REACT_APP_WARNING_DAY_2) || 3,
    parseInt(process.env.REACT_APP_WARNING_DAY_3) || 1,
  ],
};

// UI Messages
export const MESSAGES = {
  RATE_LIMIT: process.env.REACT_APP_RATE_LIMIT_MESSAGE || 'Maximum 3 OTP requests per hour per phone number',
  OTP_SENT: process.env.REACT_APP_OTP_SENT_MESSAGE || 'OTP sent successfully to your WhatsApp number',
  CHECK_WHATSAPP: process.env.REACT_APP_CHECK_WHATSAPP_MESSAGE || 'Check your WhatsApp for the 6-digit verification code',
  WHATSAPP_SECURITY: process.env.REACT_APP_WHATSAPP_SECURITY_MESSAGE || 'OTP will be sent to your WhatsApp on your primary mobile device. For security reasons, OTP messages will not appear in WhatsApp Web sessions. Please check your mobile device.',
};
